import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__logo" onClick={closeMenu}>
          ilhompc
        </Link>

        <nav className={`header__nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/ready-builds" onClick={closeMenu}>Готовые сборки</Link>
          <Link to="/laptops" onClick={closeMenu}>Ноутбуки</Link>
          <Link to="/components" onClick={closeMenu}>Комплектующие</Link>
          <Link to="/monitors" onClick={closeMenu}>Мониторы</Link>
          <Link to="/accessories" onClick={closeMenu}>Аксессуары</Link> {/* <-- добавлено */}
        </nav>

        <div className={`burger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span />
          <span />
          <span />
        </div>
      </div>
    </header>
  );
}

export default Header;
